import React, { useEffect } from "react";
import "./FullPagePopover.scss";
import parse from "html-react-parser";
import { close } from "../../assets/images/icons";

const FullPagePopover = ({
  title,
  children,
  isOpen,
  setIsOpen,
  onClose = () => {},
  wrapperClassname,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  return isOpen ? (
    <div
      className={`${
        isOpen ? "sheet-open" : "sheet-closed"
      }`}
    >
      <div className={`sheetContainer ${wrapperClassname}`}>
        <div className="sheetHeader">
          <span
            onClick={() => {
              setIsOpen(false);
              onClose?.();
            }}
          >
            {parse(close)}
          </span>
          <span>{title}</span>
        </div>
        <div className="sheetContent">{children}</div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default FullPagePopover;
